import React from 'react';
import { SortableContainer } from 'react-sortable-hoc';

export default SortableContainer(({ children }) => <div className="replies-container">{children}</div>);
